<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="13.5" height="13.5">
    <g transform="translate(-1.496 -1.496)" fill="none" stroke="#840000" stroke-width="1.5">
      <circle cx="6" cy="6" r="6" transform="translate(2.246 2.246)"/>
      <path d="M3.746 4.746l9 7"/>
    </g>
  </svg>
</template>
